import { render, staticRenderFns } from "./ViewClaim.vue?vue&type=template&id=c5ba2d70&scoped=true"
import script from "./ViewClaim.vue?vue&type=script&lang=js"
export * from "./ViewClaim.vue?vue&type=script&lang=js"
import style0 from "./ViewClaim.vue?vue&type=style&index=0&id=c5ba2d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba2d70",
  null
  
)

export default component.exports